import http from '@/services/http'
import type * as Types from './types'
/**
 * 获取物流渠道的门店信息
 */
export const getStaionInfoByCode = (params: Types.StationInfoGetReq) => http.admin.post<Types.StationInfoGetRes>('/api/station/get-station-info', params)

/** 获取门店地址列表 */
export const fetchStoreAreaList = async (params: Types.FetchStationAreaListParams) => {
  const response = await http.admin.post<{ areaNodes: Types.StoreAreaList }>('/api/station/list-child', params)

  return response.data?.areaNodes
}

/** 获取门店列表  */
export const fetchStationList = async (payload: Types.StationPageReq) => {
  const params = Object.assign({ pageSize: 20, pageNum: 1 }, payload || {})
  const response = await http.admin.post<Types.StationPageRes>('/api/station/list', params)
  return response.data
}
